var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99991 0.621033C4.3965 0.621033 3.09668 1.92085 3.09668 3.52426C3.09668 5.12767 4.3965 6.42748 5.99991 6.42748C7.60334 6.42748 8.90313 5.12767 8.90313 3.52426C8.90313 1.92085 7.60334 0.621033 5.99991 0.621033Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90323 7.97586C1.29982 7.97586 0 9.27565 0 10.8791V11.7991C0 12.3822 0.422617 12.8794 0.998144 12.9734C4.31079 13.5142 7.68921 13.5142 11.0018 12.9734C11.5774 12.8794 12 12.3822 12 11.7991V10.8791C12 9.27565 10.7002 7.97586 9.09677 7.97586H8.83285C8.69001 7.97586 8.5481 7.99847 8.41231 8.04275L7.74224 8.26162C6.61014 8.63122 5.38986 8.63122 4.25775 8.26162L3.58767 8.04275C3.45189 7.99847 3.30996 7.97586 3.16712 7.97586H2.90323Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDark);
export default __webpack_public_path__ + "static/media/profileDark.bca73560dec8a32018b03f09ea3346cf.svg";
export { ForwardRef as ReactComponent };